import { ListAtributosIrfeResolver } from './resolver/list-atributos-irfe.resolver';
import { DetalheIrfeListComponent } from './consulta-geral/detalhe-irfe-list/detalhe-irfe-list.component';
import { RouterModule, Routes } from "@angular/router";
import { BiTematicaEditComponent } from "./admin-spgg/bi-tematica-edit/bi-tematica-edit.component";
import { BiTematicaListComponent } from "./admin-spgg/bi-tematica-list/bi-tematica-list.component";
import { DadosAdicionaisModeloEditComponent } from "./admin-spgg/dados-adicionais-modelo-edit/dados-adicionais-modelo-edit.component";
import { DadosAdicionaisModeloListComponent } from "./admin-spgg/dados-adicionais-modelo-list/dados-adicionais-modelo-list.component";
import { ConfiguracaoGeralComponent } from "./admin-spgg/geral/configuracao-geral.component";
import { OrgaoSetorialistaEditComponent } from "./admin-spgg/orgao-setorialista-edit/orgao-setorialista-edit.component";
import { OrgaoSetorialistaListComponent } from "./admin-spgg/orgao-setorialista-list/orgao-setorialista-list.component";
import { PontosCriticosTiposEditComponent } from "./admin-spgg/pontos-criticos-tipos-edit/pontos-criticos-tipos-edit.component";
import { PontosCriticosTiposListComponent } from "./admin-spgg/pontos-criticos-tipos-list/pontos-criticos-tipos-list.component";
import { SgoModuloEditComponent } from "./admin-spgg/sgo-modulo-edit/sgo-modulo-edit.component";
import { SgoModuloListComponent } from "./admin-spgg/sgo-modulo-list/sgo-modulo-list.component";
import { SgoSituacoesDemandaEditComponent } from "./admin-spgg/sgo-situacoes-demanda-edit/sgo-situacoes-demanda-edit.component";
import { SgoSituacoesDemandaListComponent } from "./admin-spgg/sgo-situacoes-demanda-list/sgo-situacoes-demanda-list.component";
import { StatusOperacionalEditComponent } from "./admin-spgg/status-operacional-edit/status-operacional-edit.component";
import { StatusOperacionalListComponent } from "./admin-spgg/status-operacional-list/status-operacional-list.component";
import { DetalheCadastroProjetoComponent } from "./consulta-geral/detalhe-cadastro-projeto/detalhe-cadastro-projeto.component";
import { DetalheProjetoLayoutComponent } from "./consulta-geral/detalhe-projeto-layout/detalhe-projeto-layout.component";
import { PesquisaGeralComponent } from "./consulta-geral/pesquisa-geral/pesquisa-geral.component";
import { DemandasMonitoramentoListComponent } from "./demandas-monitoramento-list/demandas-monitoramento-list.component";
import { ExportarDropboxEditComponent } from "./exportar-dropbox-edit/exportar-dropbox-edit.component";
import { ExportarDropboxListComponent } from "./exportar-dropbox-list/exportar-dropbox-list.component";
import { ExportarListComponent } from "./exportar/exportar-list/exportar-list.component";
import { ImportarIrcpComponent } from "./importar-ircp/importar-ircp.component";
import { BiTematicaResolver } from "./resolver/bi-tematica.resolver";
import { DadosAdicionaisModeloResolver } from "./resolver/dados-adicionais-modelo.resolver";
import { ListAndamentoDemandasResolver, ListSituacaoDemandasResolver, InfoDemandaResolver } from "./resolver/demandas-monitoramento-list.resolver";
import { ExportarDropboxResolver } from "./resolver/exportar-dropbox.resolver";
import { ListExecutionResolver } from "./resolver/list-execution.resolver";
import { ListExportTypesResolver } from "./resolver/list-export-types.resolver";
import { ListOrgaoAgregadorResolver, ListOrgaoAllResolver, ListOrgaoProgramaResolver, ListOrgaoResolver } from "./resolver/list-orgao.resolver";
import { ListQuestionResolver } from "./resolver/list-question.resolver";
import { ListUsuarioResolver } from "./resolver/list-usuario.resolver";
import { OrgaoSetorialistaResolver } from "./resolver/orgao-setorialista.resolver";
import { PontosCriticosTiposResolver } from "./resolver/pontos-criticos-tipos.resolver";
import { CadastroProjectResolver, DocumentosProjetoResolver, InfoProjetoResolver, InfoProjetoStorageResolver, ProjectPermissionResolver } from "./resolver/projeto.resolver";
import { SgoModuloListResolver } from "./resolver/sgo-modulo-list.resolver";
import { SgoModuloResolver } from "./resolver/sgo-modulo.resolver";
import { SgoSituacoesDemandaResolver } from "./resolver/sgo-situacao-demanda.resolver";
import { StatusOperacionalResolver } from "./resolver/status-operacionais.resolver";
import { DetalheCadastroProdutoListComponent } from "./consulta-geral/detalhe-cadastro-produto-list/detalhe-cadastro-produto-list.component";
import { DetalheDocumentoListComponent } from "./consulta-geral/detalhe-documento-list/detalhe-documento-list.component";
import { DetalheDocumentoEditComponent } from "./consulta-geral/detalhe-documento-edit/detalhe-documento-edit.component";
import { MinhasResponsabilidadesListComponent } from "./minhas-responsabilidades-list/minhas-responsabilidades-list.component";
import { DetalheCadastroProdutoEditComponent } from "./consulta-geral/detalhe-cadastro-produto-edit/detalhe-cadastro-produto-edit.component";
import { DetalheProjetoObrasListComponent } from "./consulta-geral/detalhe-projeto-obras-list/detalhe-projeto-obras-list.component";
import { ProdutoProjetoResolver } from "./resolver/produto.resolver";
import { DetalheEntregaProjetoListComponent } from "./consulta-geral/detalhe-entrega-projeto-list/detalhe-entrega-projeto-list.component";
import { DetalheEntregaProjetoEditComponent } from "./consulta-geral/detalhe-entrega-projeto-edit/detalhe-entrega-projeto-edit.component";
import { DetalheEntregaProjetoViewComponent } from "./consulta-geral/detalhe-entrega-projeto-view/detalhe-entrega-projeto-view.component";
import { EntregasProjetoListEditResolver, EntregasProjetoListResolver, EntregasProjetoRelatorioResolver, EntregasProjetoResolver, EntregasSimplificadaProjetoResolver } from "./resolver/entregas-projeto.resolver";
import { DetalheProjetoAnalisesListComponent } from "./consulta-geral/detalhe-projeto-analises-list/detalhe-projeto-analises-list.component";
import { AnalisesGerenteProjetoResolver } from "./resolver/analises-gerente-projeto.resolver";
import { DetalheProjetoAnalisesGerenteEditComponent } from "./consulta-geral/detalhe-projeto-analises-gerente-edit/detalhe-projeto-analises-gerente-edit.component";
import { DetalheProjetoAnalisesSpggEditComponent } from "./consulta-geral/detalhe-projeto-analises-spgg-edit/detalhe-projeto-analises-spgg-edit.component";
import { AnalisesSpggProjetoResolver } from "./resolver/analises-spgg-projeto.resolver";
import { DetalheCadastroProjetoEditComponent } from "./consulta-geral/detalhe-cadastro-projeto-edit/detalhe-cadastro-projeto-edit.component";
import { ListAtributosProjetoResolver } from "./resolver/list-atributos-projeto.resolver";
import { DetalheProjetoSgoListComponent } from "./consulta-geral/detalhe-projeto-sgo-list/detalhe-projeto-sgo-list.component";
import { DetalheIrfeEditComponent } from './consulta-geral/detalhe-irfe-edit/detalhe-irfe-edit.component';
import { AditivoIrfeInitResolver, AditivoIrfeResolver, IrfeProjetoResolver, TiposAditivosIrfeListResolver } from './resolver/irfe.resolver';
import { DetalheProjetoIrcpListComponent } from "./consulta-geral/detalhe-projeto-ircp-list/detalhe-projeto-ircp-list.component";
import { DetalheProjetoIrcpEditComponent } from "./consulta-geral/detalhe-projeto-ircp-edit/detalhe-projeto-ircp-edit.component";
import { DetalheDemandasMonitoramentoListComponent } from "./consulta-geral/detalhe-demandas-monitoramento-list/detalhe-demandas-monitoramento-list.component";
import { DetalheDemandasMonitoramentoEditComponent } from "./consulta-geral/detalhe-demandas-monitoramento-edit/detalhe-demandas-monitoramento-edit.component";
import { DetalheDemandasMonitoramentoMensagensEditComponent } from "./consulta-geral/detalhe-demandas-monitoramento-mensagens-edit/detalhe-demandas-monitoramento-mensagens-edit.component";
import { AditivoIrcpInitResolver, AditivoIrcpResolver, IrcpProjetoCombosResolver, IrcpProjetoResolver, TiposAditivosIrcpListResolver } from "./resolver/ircp-projeto.resolver";
import { DemandasMonitoramentoMensagensComponent } from "./demandas-monitoramento-mensagens/demandas-monitoramento-mensagens.component";
import { DemandasMonitoramentoCadastroComponent } from "./demandas-monitoramento-cadastro/demandas-monitoramento-cadastro.component";
import { DetalheProjetoIndicadoresListComponent } from './consulta-geral/detalhe-projeto-indicadores-list/detalhe-projeto-indicadores-list.component';
import { DetalheProjetoIndicadoresViewComponent } from './consulta-geral/detalhe-projeto-indicadores-view/detalhe-projeto-indicadores-view.component';
import { DetalheProjetoIndicadoresEditComponent } from './consulta-geral/detalhe-projeto-indicadores-edit/detalhe-projeto-indicadores-edit.component';
import { IndicadoresProjetoListEditResolver, IndicadoresProjetoListResolver, IndicadoresProjetoResolver, IndicadoresSimplificadoProjetoResolver } from './resolver/indicadores-projeto.resolver';
import { DetalheEntregaProjetoRelatorioComponent } from './consulta-geral/detalhe-entrega-projeto-relatorio/detalhe-entrega-projeto-relatorio.component';
import { GenericGuard } from 'src/app/shared/guards/generic.guard';
import { DetalheCronogramaProjetoListComponent } from './consulta-geral/detalhe-cronograma-projeto-list/detalhe-cronograma-projeto-list.component';
import { DetalheProjetoPlanoAcaoEditComponent } from './consulta-geral/detalhe-projeto-plano-acao-edit/detalhe-projeto-plano-acao-edit.component';
import { PlanoAcaoListResolver, PlanoAcaoResolver, PlanoAcaoSimplificadoResolver } from './resolver/plano-acao.resolver';
import { DetalheProjetoPlanoAcaoViewComponent } from './consulta-geral/detalhe-projeto-plano-acao-view/detalhe-projeto-plano-acao-view.component';
import { DetalheProjetoSituacaoEditComponent } from './consulta-geral/detalhe-projeto-situacao-edit/detalhe-projeto-situacao-edit.component';
import { PlanoAcaoSituacaoListResolver, PlanoAcaoSituacaoResolver } from './resolver/plano-acao-situacao.resolver';
import { ConsultaGeralGuard } from 'src/app/shared/guards/consulta-geral.guard';
import { DetalheProjetoPontosCriticosListComponent } from './consulta-geral/detalhe-projeto-pontos-criticos-list/detalhe-projeto-pontos-criticos-list.component';
import { DetalheProjetoPontosCriticosEditComponent } from './consulta-geral/detalhe-projeto-pontos-criticos-edit/detalhe-projeto-pontos-criticos-edit.component';
import { PontosCriticosProjetoResolver } from './resolver/pontos-criticos-projeto.resolver';
import { PontosCriticosEntregaResolver } from './resolver/pontos-criticos-entrega.resolver';
import { PontosCriticosIndicadorResolver } from './resolver/pontos-criticos-indicador.resolver';
import { IndicadoresAnaliseListResolver, IndicadoresAnaliseResolver } from './resolver/indicadores-analise.resolver';
import { DetalheProjetoIndicadoresAnaliseEditComponent } from './consulta-geral/detalhe-projeto-indicadores-analise-edit/detalhe-projeto-indicadores-analise-edit.component';
import { DetalheEntregaProjetoAnaliseEditComponent } from './consulta-geral/detalhe-entrega-projeto-analise-edit/detalhe-entrega-projeto-analise-edit.component';
import { EntregasAnaliseListResolver, EntregasAnaliseResolver } from './resolver/entregas-analise.resolver';
import { PreDemandaResolver } from './resolver/demanda-monitoramento.resolver';
import { IndicadoresAtividadeListResolver, IndicadoresAtividadeResolver, IndicadoresAtividadeSimplificadoResolver } from './resolver/indicadores-atividade.resolver';
import { IndicadoresAtividadeSituacaoListResolver, IndicadoresAtividadeSituacaoResolver } from './resolver/indicadores-atividade-situacao.resolver';
import { DetalheProjetoProaEditComponent } from './consulta-geral/detalhe-projeto-proa-edit/detalhe-projeto-proa-edit.component';
import { DetalheProjetoExecucaoOrcamentariaEditComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-edit/detalhe-projeto-execucao-orcamentaria-edit.component';
import { DetalheProjetoExecucaoOrcamentariaViewComponent } from './consulta-geral/detalhe-projeto-execucao-orcamentaria-view/detalhe-projeto-execucao-orcamentaria-view.component';
import { ExecucaoOrcamentariaAuditoriaResolver, ExecucaoOrcamentariaPermissionResolver } from './resolver/execucao-orcamentaria.resolver';
import { DetalhePgIndicadoresEditComponent } from './consulta-geral/detalhe-pg-indicadores-edit/detalhe-pg-indicadores-edit.component';
import { DetalhePgIndicadoresViewComponent } from './consulta-geral/detalhe-pg-indicadores-view/detalhe-pg-indicadores-view.component';
import { IndicadoresPgListEditResolver, IndicadoresPgListResolver, IndicadoresPgResolver, IndicadoresSimplificadoPgResolver } from './resolver/indicadores-pg.resolver';
import { DetalhePgDocumentoEditComponent } from './consulta-geral/detalhe-pg-documento-edit/detalhe-pg-documento-edit.component';
import { DetalhePgLayoutComponent } from './consulta-geral/detalhe-pg-layout/detalhe-pg-layout.component';
import { IndicadoresPgAtividadeListResolver, IndicadoresPgAtividadeResolver, IndicadoresPgAtividadeSimplificadoResolver } from './resolver/indicadores-pg-atividade.service';
import { ComboVinculosProaResolver, ProasProjetoResolver } from './resolver/proa.resolver';

import { IndicadoresPgAtividadeSituacaoListResolver, IndicadoresPgAtividadeSituacaoResolver } from './resolver/indicadores-pg-atividade-situacao.resolver';
import { IndicadoresPgAnaliseListResolver, IndicadoresPgAnaliseResolver } from './resolver/indicadores-pg-analise.resolver';
import { DetalhePgIndicadoresAnaliseEditComponent } from './consulta-geral/detalhe-pg-indicadores-analise-edit/detalhe-pg-indicadores-analise-edit.component';
import { DetalhePgIndicadoresListComponent } from './consulta-geral/detalhe-pg-indicadores-list/detalhe-pg-indicadores-list.component';
import { AgregadorCadastroViewComponent } from './consulta-geral/agregador/view/agregador-cadastro-view/agregador-cadastro-view.component';
import { AgregadorListaViewComponent } from './consulta-geral/agregador/view/agregador-lista-view/agregador-lista-view.component';
import { AgregadorCadastroEditComponent } from './consulta-geral/agregador/edit/agregador-cadastro-edit/agregador-cadastro-edit.component';
import { PontosCriticosAgregadorIndicadorResolver } from './resolver/pontos-criticos-agregador-indicador.resolver';
import { AgregadorCadastroAddComponent } from './consulta-geral/agregador/add/agregador-cadastro-add/agregador-cadastro-add.component';
import { AgregadorLayoutComponent } from './consulta-geral/agregador/agregador-layout.component';
import { PesquisaProjetoAgregadorComponent } from './consulta-projeto-agregador/consulta-projeto-agregador.component';
import { PesquisaProgramaComponent } from './programa/pesquisa-programa/pesquisa-programa.component';
import { ProgramaEditComponent } from './programa/programa-edit/programa-edit.component';
import { ProgramaResolver } from './resolver/programa.resolver';
import { ProgramaLayoutComponent } from './programa/programa-layout.component';
import { ProgramaViewComponent } from './programa/programa-view/programa-view.component';
import { ProgramaAgregadorListComponent } from './programa/programa-agregador-list/programa-agregador-list.component';
import { ProjetoAddComponent } from './projeto/projeto-add/projeto-add.component';
import { ProgramaProjetoListComponent } from './programa/programa-projeto-list/programa-projeto-list.component';
import { DadoAdicionalItemEditComponent } from './admin-spgg/dado-adicional-item/dado-adicional-item-edit/dado-adicional-item-edit.component';
import { DadoAdicionalItemListComponent } from './admin-spgg/dado-adicional-item/dado-adicional-item-list/dado-adicional-item-list.component';
import { MapaComponent } from './mapa/mapa.component';
import { MapaResolver } from './resolver/mapa.resolver';
import { ValidateRouteGuard } from 'src/app/shared/guards/validate-route.guard';
import { AditivoIrcpIrfeEditComponent } from './consulta-geral/aditivo-ircp-irfe-edit/aditivo-ircp-irfe-edit.component';
import { PontosCriticosAcaoEditComponent } from './consulta-geral/pontos-criticos-acao-edit/pontos-criticos-acao-edit.component';
import { PontosCriticosAcaoViewComponent } from './consulta-geral/pontos-criticos-acao-view/pontos-criticos-acao-view.component';
import { AcaoStatusListEntregaResolver, AcaoStatusListIndicadorResolver, AcaoStatusListResolver, PontoCriticoAcaoResolver, PontoCriticoAcaoSimplificadoResolver, PontoCriticoAgregadorIndicadorAcaoResolver, PontoCriticoAgregadorIndicadorAcaoSimplificadoResolver, PontoCriticoEntregaAcaoResolver, PontoCriticoEntregaAcaoSimplificadoResolver, PontoCriticoIndicadorAcaoResolver, PontoCriticoIndicadorAcaoSimplificadoResolver } from './resolver/pontos-criticos-acao.resolver';
import { PontosCriticosAcaoSituacaoEditComponent } from './consulta-geral/pontos-criticos-acao-situacao-edit/pontos-criticos-acao-situacao-edit.component';
import { PontoCriticoAcaoSituacaoResolver, PontoCriticoAgregadorIndicadorAcaoSituacaoResolver, PontoCriticoEntregaAcaoSituacaoResolver, PontoCriticoIndicadorAcaoSituacaoResolver, PontosCriticosAcaoSituacaoAgregadorIndicadorInitValuesResolver, PontosCriticosAcaoSituacaoEntregaInitValuesResolver, PontosCriticosAcaoSituacaoIndicadorInitValuesResolver, PontosCriticosAcaoSituacaoInitValuesResolver } from './resolver/pontos-criticos-acao-situacao.resolver';
import { AgregadorResolver } from './resolver/agregador.resolver';
import { ProgramaAddComponent } from './programa/programa-add/programa-add.component';
import { PfTutorialListComponent } from './pf-tutorial-list/pf-tutorial-list.component';
import { PfTutorialEditComponent } from './pf-tutorial-edit/pf-tutorial-edit.component';
import { ProjetoGanttComponent } from '../gantt/component/projeto-gantt/projeto-gantt.component';
import { ProcessoAllListComponent } from './consulta-geral/processos/components/processo-all-list/processo-all-list.component';
import { ProcessoEditComponent } from './consulta-geral/processos/components/processo-edit/processo-edit.component';

const routes: Routes = [
  { path: '', redirectTo: 'projetos/projeto', pathMatch: 'full' },
  {
    path: 'projeto',
    children: [
      {
        path: '',
        component: PesquisaGeralComponent,
        resolve: { listOrgao: ListOrgaoAllResolver }
      },
      {
        path: 'adicionar',
        component: ProjetoAddComponent,
        resolve: {
          listUsuario: ListUsuarioResolver,
          listAtributosProjeto: ListAtributosProjetoResolver,
        },
        children: [
          {
            path: '',
            component: DetalheCadastroProjetoEditComponent
          }
        ]
      },
      {
        path: ':idProjeto',
        component: DetalheProjetoLayoutComponent,
        resolve: {
          infoProjeto: InfoProjetoResolver,
          permissions: ProjectPermissionResolver
        },
        children: [
          { path: '', redirectTo: 'cadastro', pathMatch: "full" },
          {
            path: 'cadastro',
            children: [
              {
                path: '',
                component: DetalheCadastroProjetoComponent,
              },
              {
                path: 'editar', component: DetalheCadastroProjetoEditComponent,
                resolve: {
                  entity: CadastroProjectResolver,
                  listUsuario: ListUsuarioResolver,
                  listAtributosProjeto: ListAtributosProjetoResolver,
                }
              },
            ]
          },
          {
            path: 'produto',
            children: [
              { path: '', component: DetalheCadastroProdutoListComponent },
              { path: 'adicionar', component: DetalheCadastroProdutoEditComponent },
              {
                path: ':id', component: DetalheCadastroProdutoEditComponent, resolve: { entity: ProdutoProjetoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_product_id' },
              },
            ]
          },
          {
            path: 'entregas',
            children: [
              { path: '', component: DetalheEntregaProjetoListComponent },
              {
                path: 'adicionar', component: DetalheEntregaProjetoEditComponent,
                resolve: { listUsuario: ListUsuarioResolver, list: EntregasProjetoListResolver }
              },
              {
                path: ':id/editar', component: DetalheEntregaProjetoEditComponent,
                resolve: { entity: EntregasProjetoResolver, listUsuario: ListUsuarioResolver, list: EntregasProjetoListEditResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_id' },
              },
              {
                path: ':id/clonar', component: DetalheEntregaProjetoEditComponent,
                resolve: { entity: EntregasProjetoResolver, listUsuario: ListUsuarioResolver, list: EntregasProjetoListEditResolver },
                data: { clone: true },
              },
              // {
              //   path: ':id/relatorio', component: DetalheEntregaProjetoRelatorioComponent, // não utilizado
              // },
              {
                path: 'analise',
                children: [
                  { path: 'adicionar', component: DetalheEntregaProjetoAnaliseEditComponent, resolve: { list: EntregasAnaliseListResolver } },
                  {
                    path: ':id/editar', component: DetalheEntregaProjetoAnaliseEditComponent, resolve: { entity: EntregasAnaliseResolver, list: EntregasAnaliseListResolver },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_analysis_id' },
                  },
                ],
              },
              {
                path: ':id', component: DetalheEntregaProjetoViewComponent,
                resolve: { entity: EntregasSimplificadaProjetoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_id' },
              },
              {
                path: ':idEntrega/ponto-critico/adicionar', component: DetalheProjetoPontosCriticosEditComponent,
                resolve: { listUsuario: ListUsuarioResolver },
              },
              {
                path: ':idEntrega/ponto-critico/:idPontoCriticoEntrega',
                children: [
                  {
                    path: '', component: DetalheProjetoPontosCriticosEditComponent,
                    resolve: { entity: PontosCriticosEntregaResolver, listUsuario: ListUsuarioResolver },
                  },
                  {
                    path: 'plano-acao',
                    children: [
                      {
                        path: 'adicionar', component: PontosCriticosAcaoEditComponent,
                        resolve: { listUsuario: ListUsuarioResolver, list: AcaoStatusListEntregaResolver },
                      },
                      {
                        path: ':idAcao',
                        children: [
                          {
                            path: '', component: PontosCriticosAcaoViewComponent,
                            resolve: { entity: PontoCriticoEntregaAcaoSimplificadoResolver },
                          },
                          {
                            path: 'editar', component: PontosCriticosAcaoEditComponent,
                            resolve: { entity: PontoCriticoEntregaAcaoResolver, listUsuario: ListUsuarioResolver, list: AcaoStatusListEntregaResolver },
                          },
                          {
                            path: 'situacao',
                            children: [
                              {
                                path: 'adicionar', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { list: PontosCriticosAcaoSituacaoEntregaInitValuesResolver, },
                              },
                              {
                                path: ':idSituacao', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { entity: PontoCriticoEntregaAcaoSituacaoResolver },
                              }
                            ]
                          }
                        ]
                      },
                    ]
                  },
                ]
              },
            ]
          },
          {
            path: 'plano-acao',
            children: [
              {
                path: 'adicionar', component: DetalheProjetoPlanoAcaoEditComponent,
                resolve: { listUsuario: ListUsuarioResolver, list: PlanoAcaoListResolver }
              },
              {
                path: ':id/editar', component: DetalheProjetoPlanoAcaoEditComponent,
                resolve: { entity: PlanoAcaoResolver, listUsuario: ListUsuarioResolver, list: PlanoAcaoListResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_action_id' },
              },
              {
                path: 'situacao',
                children: [
                  {
                    path: ':id/adicionar', component: DetalheProjetoSituacaoEditComponent,
                    resolve: { list: PlanoAcaoSituacaoListResolver, },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_action_id' },
                  },
                  {
                    path: ':id/editar', component: DetalheProjetoSituacaoEditComponent,
                    resolve: { entity: PlanoAcaoSituacaoResolver },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_action_analysis_id' },
                  }
                ]
              },
              {
                path: ':id', component: DetalheProjetoPlanoAcaoViewComponent,
                resolve: { entity: PlanoAcaoSimplificadoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_action_id' },
              },
            ]
          },
          {
            path: 'indicadores',
            children: [
              { path: '', component: DetalheProjetoIndicadoresListComponent },
              {
                path: 'adicionar', component: DetalheProjetoIndicadoresEditComponent,
                resolve: { listUsuario: ListUsuarioResolver, list: IndicadoresProjetoListResolver }
              },
              {
                path: ':id/editar', component: DetalheProjetoIndicadoresEditComponent,
                resolve: { entity: IndicadoresProjetoResolver, listUsuario: ListUsuarioResolver, list: IndicadoresProjetoListEditResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_indicator_id' },
              },
              {
                path: ':id/clonar', component: DetalheProjetoIndicadoresEditComponent,
                resolve: { entity: IndicadoresProjetoResolver, listUsuario: ListUsuarioResolver, list: IndicadoresProjetoListEditResolver },
                data: { clone: true },
              },
              {
                path: 'analise',
                children: [
                  { path: 'adicionar', component: DetalheProjetoIndicadoresAnaliseEditComponent, resolve: { list: IndicadoresAnaliseListResolver } },
                  {
                    path: ':id/editar', component: DetalheProjetoIndicadoresAnaliseEditComponent, resolve: { entity: IndicadoresAnaliseResolver, list: IndicadoresAnaliseListResolver },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_analysis_id' },
                  },
                ],
              },
              {
                path: ':id', component: DetalheProjetoIndicadoresViewComponent,
                resolve: { entity: IndicadoresSimplificadoProjetoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_indicator_id' },
              },
              {
                path: ':idIndicador/ponto-critico/adicionar', component: DetalheProjetoPontosCriticosEditComponent,
                resolve: { listUsuario: ListUsuarioResolver },
              },
              {
                path: ':idIndicador/ponto-critico/:idPontoCriticoIndicador',
                children: [
                  {
                    path: '', component: DetalheProjetoPontosCriticosEditComponent,
                    resolve: { entity: PontosCriticosIndicadorResolver, listUsuario: ListUsuarioResolver },
                  },
                  {
                    path: 'plano-acao',
                    children: [
                      {
                        path: 'adicionar', component: PontosCriticosAcaoEditComponent,
                        resolve: { listUsuario: ListUsuarioResolver, list: AcaoStatusListIndicadorResolver },
                      },
                      {
                        path: ':idAcao',
                        children: [
                          {
                            path: '', component: PontosCriticosAcaoViewComponent,
                            resolve: { entity: PontoCriticoIndicadorAcaoSimplificadoResolver },
                          },
                          {
                            path: 'editar', component: PontosCriticosAcaoEditComponent,
                            resolve: { entity: PontoCriticoIndicadorAcaoResolver, listUsuario: ListUsuarioResolver, list: AcaoStatusListIndicadorResolver },
                          },
                          {
                            path: 'situacao',
                            children: [
                              {
                                path: 'adicionar', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { list: PontosCriticosAcaoSituacaoIndicadorInitValuesResolver, },
                              },
                              {
                                path: ':idSituacao', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { entity: PontoCriticoIndicadorAcaoSituacaoResolver },
                              }
                            ]
                          }
                        ]
                      },
                    ]
                  },
                ]
              },
            ]
          },
          {
            path: 'atividade',
            children: [
              {
                path: 'adicionar', component: DetalheProjetoPlanoAcaoEditComponent,
                resolve: { listUsuario: ListUsuarioResolver, list: IndicadoresAtividadeListResolver }
              },
              {
                path: ':id/editar', component: DetalheProjetoPlanoAcaoEditComponent,
                resolve: { entity: IndicadoresAtividadeResolver, listUsuario: ListUsuarioResolver, list: IndicadoresAtividadeListResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_action_id' },
              },
              {
                path: 'situacao',
                children: [
                  {
                    path: ':id/adicionar', component: DetalheProjetoSituacaoEditComponent, resolve: { list: IndicadoresAtividadeSituacaoListResolver, },
                    canActivate: [ValidateRouteGuard], data: { isIndicador: true, parametro: 'pf_ind_action_id' },
                  },
                  {
                    path: ':id/editar', component: DetalheProjetoSituacaoEditComponent, resolve: { entity: IndicadoresAtividadeSituacaoResolver },
                    canActivate: [ValidateRouteGuard], data: { isIndicador: true, parametro: 'pf_ind_action_analysis_id' },
                  }
                ]
              },
              {
                path: ':id', component: DetalheProjetoPlanoAcaoViewComponent,
                resolve: { entity: IndicadoresAtividadeSimplificadoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_action_id', isIndicador: true },
              },
            ]
          },
          {
            path: 'documentos',
            children: [
              { path: '', component: DetalheDocumentoListComponent },
              { path: 'adicionar', component: DetalheDocumentoEditComponent },
              {
                path: ':id', component: DetalheDocumentoEditComponent,
                resolve: { entity: DocumentosProjetoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_doc_id' },
              },
            ]
          },
          {
            path: 'execucao-orcamentaria',
            children: [
              { path: '', component: DetalheProjetoExecucaoOrcamentariaEditComponent },
              {
                path: ':id', component: DetalheProjetoExecucaoOrcamentariaViewComponent, resolve: { permission: ExecucaoOrcamentariaPermissionResolver, audit: ExecucaoOrcamentariaAuditoriaResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'execucao_orcamentaria_id' }
              },
            ]
          },
          {
            path: 'cronograma',
            children: [
              { path: '', component: DetalheCronogramaProjetoListComponent },
            ]
          },
          {
            path: 'obras',
            children: [
              { path: '', component: DetalheProjetoObrasListComponent },
            ]
          },
          {
            path: 'analises',
            children: [
              { path: '', component: DetalheProjetoAnalisesListComponent },
              { path: 'gerente/adicionar', component: DetalheProjetoAnalisesGerenteEditComponent, },
              { path: 'spgg/adicionar', component: DetalheProjetoAnalisesSpggEditComponent, },
              {
                path: 'gerente/:id', component: DetalheProjetoAnalisesGerenteEditComponent, resolve: { entity: AnalisesGerenteProjetoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_analysis_id' },
              },
              {
                path: 'spgg/:id', component: DetalheProjetoAnalisesSpggEditComponent, resolve: { entity: AnalisesSpggProjetoResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_analysis_id' },
              },
            ]
          },
          {
            path: 'sgo',
            children: [
              { path: '', component: DetalheProjetoSgoListComponent },
            ]
          },
          {
            path: 'irfe',
            children: [
              { path: '', component: DetalheIrfeListComponent },
              { path: 'adicionar', component: DetalheIrfeEditComponent, resolve: { listAtributosIrfe: ListAtributosIrfeResolver } },
              {
                path: ':id', component: DetalheIrfeEditComponent, resolve: { entity: IrfeProjetoResolver, listAtributosIrfe: ListAtributosIrfeResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_irfe_id' },
              },
              {
                path: ':id/aditivo/adicionar', component: AditivoIrcpIrfeEditComponent,
                resolve: { entity: AditivoIrfeInitResolver, tiposAditivos: TiposAditivosIrfeListResolver },
                data: { isIrcp: false, parametro: 'pf_irfe_id' },
                canActivate: [ValidateRouteGuard],
              },
              {
                path: ':id/aditivo', component: AditivoIrcpIrfeEditComponent,
                resolve: { entity: AditivoIrfeResolver, tiposAditivos: TiposAditivosIrfeListResolver },
                data: { isIrcp: false, parametro: 'pf_irfe_id' },
                canActivate: [ValidateRouteGuard],
              },
            ]
          },
          {
            path: 'demandas',
            children: [
              { path: '', component: DetalheDemandasMonitoramentoListComponent },
              { path: 'adicionar', component: DetalheDemandasMonitoramentoEditComponent, resolve: { listUsuario: ListUsuarioResolver, infoProjeto: InfoProjetoStorageResolver, preDemanda: PreDemandaResolver } },
              {
                path: ':id', component: DetalheDemandasMonitoramentoEditComponent, resolve: { listUsuario: ListUsuarioResolver, infoProjeto: InfoProjetoStorageResolver, entity: InfoDemandaResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'mf_issue_id' },
              },
              {
                path: ':id/mensagens', component: DetalheDemandasMonitoramentoMensagensEditComponent, resolve: { infoDemanda: InfoDemandaResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'mf_issue_id' },
              },
            ]
          },
          {
            path: 'ircp',
            children: [
              { path: '', component: DetalheProjetoIrcpListComponent },
              {
                path: 'adicionar', component: DetalheProjetoIrcpEditComponent,
                resolve: { listUsuario: ListUsuarioResolver, list: IrcpProjetoCombosResolver },
              },
              {
                path: ':id', component: DetalheProjetoIrcpEditComponent,
                resolve: { entity: IrcpProjetoResolver, listUsuario: ListUsuarioResolver, list: IrcpProjetoCombosResolver },
                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ircp_id' },
              },
              {
                path: ':id/aditivo/adicionar', component: AditivoIrcpIrfeEditComponent,
                resolve: { entity: AditivoIrcpInitResolver, tiposAditivos: TiposAditivosIrcpListResolver },
                data: { isIrcp: true, parametro: 'pf_ircp_id' },
                canActivate: [ValidateRouteGuard],
              },
              {
                path: ':id/aditivo', component: AditivoIrcpIrfeEditComponent,
                resolve: { entity: AditivoIrcpResolver, tiposAditivos: TiposAditivosIrcpListResolver },
                data: { isIrcp: true, parametro: 'pf_ircp_id' },
                canActivate: [ValidateRouteGuard],
              },
            ]
          },
          {path: 'processos',
            children: [
              { path: '', component: ProcessoAllListComponent },
              { path: ':entidade/:type', component: ProcessoEditComponent},
              { path: ':entidade/:type/:id', component: ProcessoEditComponent}
            ]
          },
          {
            path: 'pontos-criticos',
            children: [
              { path: '', component: DetalheProjetoPontosCriticosListComponent },
              {
                path: 'adicionar', component: DetalheProjetoPontosCriticosEditComponent,
                resolve: { listUsuario: ListUsuarioResolver }
              },
              {
                path: ':idPontoCritico',
                children: [
                  {
                    path: '', component: DetalheProjetoPontosCriticosEditComponent,
                    resolve: { entity: PontosCriticosProjetoResolver, listUsuario: ListUsuarioResolver },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_critical_id' },
                  },
                  {
                    path: 'plano-acao',
                    children: [
                      {
                        path: 'adicionar', component: PontosCriticosAcaoEditComponent,
                        resolve: { listUsuario: ListUsuarioResolver, list: AcaoStatusListResolver },
                        canActivate: [ValidateRouteGuard], data: { parametro: 'pf_critical_id' },
                      },
                      {
                        path: ':idAcao',
                        children: [
                          {
                            path: '', component: PontosCriticosAcaoViewComponent,
                            resolve: { entity: PontoCriticoAcaoSimplificadoResolver },
                            canActivate: [ValidateRouteGuard], data: { parametro: 'pf_critical_id' },
                          },
                          {
                            path: 'editar', component: PontosCriticosAcaoEditComponent,
                            resolve: { entity: PontoCriticoAcaoResolver, listUsuario: ListUsuarioResolver, list: AcaoStatusListResolver },
                            canActivate: [ValidateRouteGuard], data: { parametro: 'pf_critical_id' },
                          },
                          {
                            path: 'situacao',
                            children: [
                              {
                                path: 'adicionar', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { list: PontosCriticosAcaoSituacaoInitValuesResolver, },
                                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_critical_id' },
                              },
                              {
                                path: ':idSituacao', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { entity: PontoCriticoAcaoSituacaoResolver },
                                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_critical_id' },
                              }
                            ]
                          }
                        ]
                      },
                    ]
                  },
                ]
              },

              {
                path: 'entrega/:idPontoCriticoEntrega',
                children: [
                  {
                    path: '', component: DetalheProjetoPontosCriticosEditComponent,
                    resolve: { entity: PontosCriticosEntregaResolver, listUsuario: ListUsuarioResolver },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_critical_id' },
                  },
                  {
                    path: 'plano-acao',
                    children: [
                      {
                        path: 'adicionar', component: PontosCriticosAcaoEditComponent,
                        resolve: { listUsuario: ListUsuarioResolver, list: AcaoStatusListEntregaResolver },
                        canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_critical_id' },
                      },
                      {
                        path: ':idAcao',
                        children: [
                          {
                            path: '', component: PontosCriticosAcaoViewComponent,
                            resolve: { entity: PontoCriticoEntregaAcaoSimplificadoResolver },
                            canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_critical_id' },
                          },
                          {
                            path: 'editar', component: PontosCriticosAcaoEditComponent,
                            resolve: { entity: PontoCriticoEntregaAcaoResolver, listUsuario: ListUsuarioResolver, list: AcaoStatusListEntregaResolver },
                            canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_critical_id' },
                          },
                          {
                            path: 'situacao',
                            children: [
                              {
                                path: 'adicionar', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { list: PontosCriticosAcaoSituacaoEntregaInitValuesResolver, },
                                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_critical_id' },
                              },
                              {
                                path: ':idSituacao', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { entity: PontoCriticoEntregaAcaoSituacaoResolver },
                                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_prt_issue_critical_id' },
                              }
                            ]
                          }
                        ]
                      },
                    ]
                  },
                ]
              },

              {
                path: 'indicador/:idPontoCriticoIndicador',
                children: [
                  {
                    path: '', component: DetalheProjetoPontosCriticosEditComponent,
                    resolve: { entity: PontosCriticosIndicadorResolver, listUsuario: ListUsuarioResolver },
                    canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_critical_id' },
                  },
                  {
                    path: 'plano-acao',
                    children: [
                      {
                        path: 'adicionar', component: PontosCriticosAcaoEditComponent,
                        resolve: { listUsuario: ListUsuarioResolver, list: AcaoStatusListIndicadorResolver },
                        canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_critical_id' },
                      },
                      {
                        path: ':idAcao',
                        children: [
                          {
                            path: '', component: PontosCriticosAcaoViewComponent,
                            resolve: { entity: PontoCriticoIndicadorAcaoSimplificadoResolver },
                            canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_critical_id' },
                          },
                          {
                            path: 'editar', component: PontosCriticosAcaoEditComponent,
                            resolve: { entity: PontoCriticoIndicadorAcaoResolver, listUsuario: ListUsuarioResolver, list: AcaoStatusListIndicadorResolver },
                            canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_critical_id' },
                          },
                          {
                            path: 'situacao',
                            children: [
                              {
                                path: 'adicionar', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { list: PontosCriticosAcaoSituacaoIndicadorInitValuesResolver, },
                                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_critical_id' },
                              },
                              {
                                path: ':idSituacao', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { entity: PontoCriticoIndicadorAcaoSituacaoResolver },
                                canActivate: [ValidateRouteGuard], data: { parametro: 'pf_ind_critical_id' },
                              }
                            ]
                          }
                        ]
                      },
                    ]
                  },
                ]
              },
            ]
          },
          { path: 'gantt', component: ProjetoGanttComponent },
        ]
      },
    ]
  },
  {
    path: 'admin-spgg',
    data: { role: 'ACL_PF_ADMIN' }, // Defina os parâmetros aqui
    canActivate: [GenericGuard],
    children: [
      {
        path: 'geral',
        component: ConfiguracaoGeralComponent,
      },
      {
        path: 'pontos-criticos-tipos',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: PontosCriticosTiposListComponent, },
            {
              path: 'adicionar',
              component: PontosCriticosTiposEditComponent,
            },
            {
              path: ':id',
              component: PontosCriticosTiposEditComponent,
              resolve: { entity: PontosCriticosTiposResolver }
            }
          ],
      },
      {
        path: 'status-operacionais',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: StatusOperacionalListComponent, },
            {
              path: 'adicionar',
              component: StatusOperacionalEditComponent,
            },
            {
              path: ':id',
              component: StatusOperacionalEditComponent,
              resolve: { entity: StatusOperacionalResolver }
            }
          ],
      },
      {
        path: 'dados-adicionais-modelo',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: DadosAdicionaisModeloListComponent, },
            {
              path: 'adicionar',
              component: DadosAdicionaisModeloEditComponent,
              resolve: { listQuestion: ListQuestionResolver },
            },
            {
              path: ':id',
              component: DadosAdicionaisModeloEditComponent,
              resolve: { entity: DadosAdicionaisModeloResolver, listQuestion: ListQuestionResolver },
            }
          ],
      },
      {
        path: 'dados-adicionais-item',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: DadoAdicionalItemListComponent, },
            {
              path: 'adicionar',
              component: DadoAdicionalItemEditComponent,
            },
            {
              path: ':id',
              component: DadoAdicionalItemEditComponent,
            }
          ],
      },
      {
        path: 'sgo-situacoes-demanda',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: SgoSituacoesDemandaListComponent, },
            {
              path: 'adicionar',
              component: SgoSituacoesDemandaEditComponent,
              resolve: { sgoModulo: SgoModuloListResolver }
            },
            {
              path: ':id',
              component: SgoSituacoesDemandaEditComponent,
              resolve: { entity: SgoSituacoesDemandaResolver, sgoModulo: SgoModuloListResolver },
            }
          ],
      },
      {
        path: 'sgo-modulos',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: SgoModuloListComponent, },
            {
              path: 'adicionar',
              component: SgoModuloEditComponent,
            },
            {
              path: ':id',
              component: SgoModuloEditComponent,
              resolve: { entity: SgoModuloResolver },
            }
          ],
      },
      {
        path: 'orgao-setorialista',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: OrgaoSetorialistaListComponent, },
            {
              path: 'adicionar',
              component: OrgaoSetorialistaEditComponent,
              resolve: { listOrgao: ListOrgaoResolver, listusuario: ListUsuarioResolver },
            },
            {
              path: ':id',
              component: OrgaoSetorialistaEditComponent,
              resolve: { entity: OrgaoSetorialistaResolver, listOrgao: ListOrgaoResolver, listusuario: ListUsuarioResolver },
            }
          ],
      },
      {
        path: 'bi-tematica',
        children:
          [
            { path: '', redirectTo: 'list', pathMatch: "full" },
            { path: 'list', component: BiTematicaListComponent, },
            {
              path: 'adicionar',
              component: BiTematicaEditComponent,
            },
            {
              path: ':id',
              component: BiTematicaEditComponent,
              resolve: { entity: BiTematicaResolver },
            }
          ],
      },
    ]
  },
  {
    path: 'mapa',
    component: MapaComponent,
  },
  {
    path: 'exportar-dropbox',
    data: { role: 'ACL_PF_PROJECT_EXPORT' },
    canActivate: [GenericGuard],
    children:
      [
        { path: '', redirectTo: 'list', pathMatch: "full" },
        { path: 'list', component: ExportarDropboxListComponent, },
        {
          path: 'adicionar',
          component: ExportarDropboxEditComponent,
          resolve: { listExportTypes: ListExportTypesResolver, listExecution: ListExecutionResolver }
        },
        {
          path: ':id',
          component: ExportarDropboxEditComponent,
          resolve: { entity: ExportarDropboxResolver, listExportTypes: ListExportTypesResolver, listExecution: ListExecutionResolver }
        }
      ],
  },
  {
    path: 'demandas-monitoramento',
    data: { role: { grupo: 'TB_GRUPO_DEMANDA' } },
    canActivate: [GenericGuard],
    children:
      [
        { path: '', redirectTo: 'list', pathMatch: "full" },
        {
          path: 'list',
          component: DemandasMonitoramentoListComponent,
          resolve: { listUsuario: ListUsuarioResolver, listAndamento: ListAndamentoDemandasResolver, listSituacao: ListSituacaoDemandasResolver },
        },
        {
          path: ':id',
          component: DemandasMonitoramentoCadastroComponent,
          resolve: { listUsuario: ListUsuarioResolver, entity: InfoDemandaResolver }
        },
        {
          path: ':id/mensagens',
          component: DemandasMonitoramentoMensagensComponent,
          resolve: { infoDemanda: InfoDemandaResolver }
        },
      ]
  },
	{
		path: 'tutoriais',
		data: { role: 'ACL_PF_DOCUMENT_GUIDE_CHECK' },
		canActivate: [GenericGuard],
		children: [
			{ path: '', component: PfTutorialListComponent },
			{ path: 'adicionar', component: PfTutorialEditComponent },
			{
				path: ':id', component: PfTutorialEditComponent,
				resolve: { entity: DocumentosProjetoResolver },
			},
		]
	},
  {
    path: 'exportar',
    data: { role: 'ACL_PF_PROJECT_EXPORT' },
    canActivate: [GenericGuard],
    children:
      [
        { path: '', redirectTo: 'list', pathMatch: "full" },
        { path: 'list', component: ExportarListComponent, },
      ],
  },
  {
    path: 'minhas-responsabilidades',
    canActivate: [ConsultaGeralGuard], // Mesma lógica usada para o Consulta Geral
    children:
      [
        { path: '', redirectTo: 'list', pathMatch: "full" },
        { path: 'list', component: MinhasResponsabilidadesListComponent, },
      ],
  },
  {
    path: 'importar',
    data: { role: 'ACL_PF_PROJECT_IMPORT' },
    canActivate: [GenericGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: "full" },
      { path: 'list', component: ImportarIrcpComponent, },
    ],
  },
  {
    path: 'agregador',
    children: [
      {
        path: '',
        component: PesquisaProjetoAgregadorComponent,
        resolve: { listOrgao: ListOrgaoAllResolver }
      },
      {
        path: 'adicionar',
        component: AgregadorCadastroAddComponent,
        resolve: { listOrgao: ListOrgaoAgregadorResolver, listUsuario: ListUsuarioResolver,listAtributosProjeto: ListAtributosProjetoResolver }
      },
      {
        path: ':idProjeto',
        component: AgregadorLayoutComponent,
        resolve: { projeto: AgregadorResolver },
        children: [
          { path: '', redirectTo: 'cadastro', pathMatch: "full" },
          {
            path: 'cadastro',
            children: [
              { path: '', component: AgregadorCadastroViewComponent },
              { path: 'editar', component: AgregadorCadastroEditComponent, resolve: { listOrgao: ListOrgaoAgregadorResolver, listUsuario: ListUsuarioResolver, listAtributosProjeto: ListAtributosProjetoResolver } },
            ]
          },
          { path: 'projetos', component: AgregadorListaViewComponent },
          { path: 'indicadores', component: DetalhePgIndicadoresListComponent }
        ]
      },
      {
        path: 'indicadores',
        children: [
          {
            path: 'analise',
            children: [
              { path: 'adicionar', component: DetalhePgIndicadoresAnaliseEditComponent, resolve: { list: IndicadoresPgAnaliseListResolver } },
              { path: ':id/editar', component: DetalhePgIndicadoresAnaliseEditComponent, resolve: { entity: IndicadoresPgAnaliseResolver, list: IndicadoresPgAnaliseListResolver } },
            ],
          },
          {
            path: ':idProjeto/adicionar', component: DetalhePgIndicadoresEditComponent,
            resolve: { listUsuario: ListUsuarioResolver, list: IndicadoresPgListResolver }
          },
          {
            path: ':id/editar', component: DetalhePgIndicadoresEditComponent,
            resolve: { entity: IndicadoresPgResolver, listUsuario: ListUsuarioResolver, list: IndicadoresPgListEditResolver }
          },
          {
            path: ':id', component: DetalhePgIndicadoresViewComponent,
            resolve: { entity: IndicadoresSimplificadoPgResolver }
          },
          {
            path: ':idPgIndicador/ponto-critico',
            children: [
              // { path: '', component: DetalheProjetoPontosCriticosListComponent },
              {
                path: 'adicionar', component: DetalheProjetoPontosCriticosEditComponent,
                resolve: { listUsuario: ListUsuarioResolver }, data: {pgIndicador: true}
              },
              {
                path: ':idPontoCriticoPgIndicador',
                children: [
                  {
                    path: '', component: DetalheProjetoPontosCriticosEditComponent,
                    resolve: { entity: PontosCriticosAgregadorIndicadorResolver, listUsuario: ListUsuarioResolver },
                    data: {pgIndicador: true}
                  },
                  {
                    path: 'plano-acao',
                    children: [
                      {
                        path: 'adicionar', component: PontosCriticosAcaoEditComponent,
                        resolve: { listUsuario: ListUsuarioResolver, list: AcaoStatusListIndicadorResolver },
                      },
                      {
                        path: ':idAcao',
                        children: [
                          {
                            path: '', component: PontosCriticosAcaoViewComponent,
                            resolve: { entity: PontoCriticoAgregadorIndicadorAcaoSimplificadoResolver },
                          },
                          {
                            path: 'editar', component: PontosCriticosAcaoEditComponent,
                            resolve: { entity: PontoCriticoAgregadorIndicadorAcaoResolver, listUsuario: ListUsuarioResolver, list: AcaoStatusListIndicadorResolver },
                          },
                          {
                            path: 'situacao',
                            children: [
                              {
                                path: 'adicionar', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { list: PontosCriticosAcaoSituacaoAgregadorIndicadorInitValuesResolver, },
                              },
                              {
                                path: ':idSituacao', component: PontosCriticosAcaoSituacaoEditComponent,
                                resolve: { entity: PontoCriticoAgregadorIndicadorAcaoSituacaoResolver },
                              }
                            ]
                          }
                        ]
                      },
                    ]
                  },
                ]
              },
            ],
          },
        ]
      },
      {
        path: 'atividade',
        component: DetalhePgLayoutComponent,
        children: [
          {
            path: 'adicionar', component: DetalheProjetoPlanoAcaoEditComponent,
            resolve: { listUsuario: ListUsuarioResolver, list: IndicadoresPgAtividadeListResolver }
          },
          {
            path: ':id/editar', component: DetalheProjetoPlanoAcaoEditComponent,
            resolve: { entity: IndicadoresPgAtividadeResolver, listUsuario: ListUsuarioResolver, list: IndicadoresPgAtividadeListResolver },
            data: { isPgIndicador: true },
          },
          {
            path: 'situacao',
            children: [
              { path: ':id/adicionar', component: DetalheProjetoSituacaoEditComponent, resolve: { list: IndicadoresPgAtividadeSituacaoListResolver, }, data: { isPgIndicador: true }, },
              { path: ':id/editar', component: DetalheProjetoSituacaoEditComponent, resolve: { entity: IndicadoresPgAtividadeSituacaoResolver }, data: { isPgIndicador: true }, }
            ]
          },
          {
            path: ':id', component: DetalheProjetoPlanoAcaoViewComponent,
            resolve: { entity: IndicadoresPgAtividadeSimplificadoResolver },
            data: { isPgIndicador: true },
          },
        ]
      },
    ]
  },

  {
    path: 'programa',
    children: [
      {
        path: '', component: PesquisaProgramaComponent,
        resolve: { listOrgao: ListOrgaoAllResolver }
      },
      {
        path: 'adicionar',
        component: ProgramaAddComponent,
        resolve: { listOrgao: ListOrgaoProgramaResolver, listUsuario: ListUsuarioResolver, listAtributosProjeto: ListAtributosProjetoResolver }
      },
      {
        path: ':idProjeto',
        component: ProgramaLayoutComponent,
        resolve: { programa: ProgramaResolver },
        children: [
          { path: '', redirectTo: 'cadastro', pathMatch: "full" },
          {
            path: 'cadastro',
            children: [
              { path: '', component: ProgramaViewComponent },
              {
                path: 'editar',
                component: ProgramaEditComponent,
                resolve: { listOrgao: ListOrgaoProgramaResolver, listUsuario: ListUsuarioResolver, listAtributosProjeto: ListAtributosProjetoResolver },
              },
            ]
          },
          {
            path: 'agregadores',
            component: ProgramaAgregadorListComponent,
          },
          {
            path: 'projetos',
            component: ProgramaProjetoListComponent,
          },
          {
            path: 'indicadores',
            component: DetalhePgIndicadoresListComponent,
            data: { type: 'programa' },
          },
        ]
      },
      {
        path: 'indicadores',
        children: [
          {
            path: 'analise',
            children: [
              { path: 'adicionar', component: DetalhePgIndicadoresAnaliseEditComponent, data: { type: 'programa' }, resolve: { list: IndicadoresPgAnaliseListResolver } },
              { path: ':id/editar', component: DetalhePgIndicadoresAnaliseEditComponent, data: { type: 'programa' }, resolve: { entity: IndicadoresPgAnaliseResolver, list: IndicadoresPgAnaliseListResolver } },
            ],
          },
          {
            path: ':idProjeto/adicionar', component: DetalhePgIndicadoresEditComponent,
            resolve: { listUsuario: ListUsuarioResolver, list: IndicadoresPgListResolver },
            data: { type: 'programa' },
          },
          {
            path: ':id/editar', component: DetalhePgIndicadoresEditComponent,
            resolve: { entity: IndicadoresPgResolver, listUsuario: ListUsuarioResolver, list: IndicadoresPgListEditResolver },
            data: { type: 'programa' },
          },
          {
            path: ':id', component: DetalhePgIndicadoresViewComponent,
            resolve: { entity: IndicadoresSimplificadoPgResolver },
            data: { type: 'programa' },
          },
        ]
      },
      {
        path: 'atividade',
        component: DetalhePgLayoutComponent,
        data: { type: 'programa' },
        children: [
          {
            path: 'adicionar', component: DetalheProjetoPlanoAcaoEditComponent,
            resolve: { listUsuario: ListUsuarioResolver, list: IndicadoresPgAtividadeListResolver },
            data: { type: 'programa' },
          },
          {
            path: ':id/editar', component: DetalheProjetoPlanoAcaoEditComponent,
            resolve: { entity: IndicadoresPgAtividadeResolver, listUsuario: ListUsuarioResolver, list: IndicadoresPgAtividadeListResolver },
            data: { type: 'programa' },
          },
          {
            path: 'situacao',
            children: [
              { path: ':id/adicionar', component: DetalheProjetoSituacaoEditComponent, resolve: { list: IndicadoresPgAtividadeSituacaoListResolver, }, data: { isPgIndicador: true, type: 'programa' }, },
              { path: ':id/editar', component: DetalheProjetoSituacaoEditComponent, resolve: { entity: IndicadoresPgAtividadeSituacaoResolver }, data: { isPgIndicador: true, type: 'programa' }, }
            ]
          },
          {
            path: ':id', component: DetalheProjetoPlanoAcaoViewComponent,
            resolve: { entity: IndicadoresPgAtividadeSimplificadoResolver },
            data: { isPgIndicador: true, type: 'programa' },
          },
        ]
      },
    ]
  },

  {
    path: 'documentos',
    children: [
      { path: 'adicionar', component: DetalhePgDocumentoEditComponent },
      { path: ':id', component: DetalhePgDocumentoEditComponent, resolve: { entity: DocumentosProjetoResolver } },
    ]
  },
];

export const ProjetoCompletoRoutes = RouterModule.forChild(routes);
